import { isLocal } from '../config/env';

const fleetPlans = [
  {
    id: "basic",
    name: "Basic",
    price: "Free",
    color: "blue",
    gradient: "from-blue-400 to-blue-600",
    borderColor: "border-blue-200",
    stripe_price_id: "price_1RjqCARvSZGBetSdv3D5mOsF",
    module: "fleet",
    features: [
      "Add up to 3 routes",
      "3 runs per month",
      "Basic user support"
    ],
    limitations: [
      // "Limited route optimization",
      // "No advanced analytics",
      // "Email support only"
    ]
  },
  {
    id: "plus",
    name: "Plus",
    price: 299,
    color: "blue",
    gradient: "from-blue-400 to-blue-600",
    borderColor: "border-blue-200",
    popular: false,
    stripe_price_id: isLocal
      ? "price_1RnSwXRvSZGBetSd0ALyh9wd"
      : "price_1RnSsnRsYZhZbIEZWmsg0xhF",
    module: "fleet",
    features: [
      "Add up to 10 routes",
      "Up to 1 depot",
      "30 runs per month",
      "Standard user support",
      "Response within 48 hours"
    ],
    limitations: []
  },
  {
    id: "professional",
    name: "Professional",
    price: 999,
    color: "blue",
    gradient: "from-blue-400 to-blue-600",
    borderColor: "border-blue-200",
    popular: false,
    stripe_price_id: isLocal
      ? "price_1RnSyuRvSZGBetSd9fde6b1G"
      : "price_1RnT2eRsYZhZbIEZszHOeI6r",
    module: "fleet",
    features: [
      "Add up to 50 routes",
      "Solar & battery integration",
      "Up to 3 depots",
      "50 runs per month",
      "Standard user support"
    ],
    limitations: []
  },
  {
    id: "enterprise",
    name: "Enterprise",
    price: 2999,
    color: "blue",
    gradient: "from-blue-400 to-blue-600",
    borderColor: "border-blue-200",
    stripe_price_id: isLocal
      ? "price_1RnSyFRvSZGBetSdCiKIpfXj"
      : "price_1RnT25RsYZhZbIEZVwFTUzyk",
    module: "fleet",
    features: [
      "Add up to 500 routes",
      "Solar & battery integration",
      "Up to 20 depots",
      "100 runs per month",
      "Professional user support"
    ],
    limitations: []
  }
];

const chargerPlans = [
  {
    id: "charger-contact",
    price: "Contact Us",
    color: "green",
    gradient: "from-green-400 to-green-600",
    borderColor: "border-green-200",
    module: "charger",
    contactOnly: true,
    features: [
      "Land parcel analysis and comparison",
      "Location demand analysis",
      "Grid capacity assessment",
      "Points of interest data",
      "Zoning and regulatory information",
      "Interactive map exploration",
      "Custom pricing available"
    ],
    limitations: []
  }
];

const allPlans = [...fleetPlans, ...chargerPlans];

const planLookup = new Map(allPlans.map(plan => [plan.id, plan]));

const FLEET_PLAN_IDS = new Set(fleetPlans.map(plan => plan.id));
const CHARGER_PLAN_IDS = new Set(chargerPlans.map(plan => plan.id));
const UTILITY_PLAN_IDS = new Set(); // Utility plans will be added when GridPlan subscriptions launch

const PLAN_ID_TO_MODULE = new Map(allPlans.map(plan => [plan.id, plan.module]));

export { fleetPlans, chargerPlans };

export const ALL_PLANS = allPlans;

export const getPlanById = (planId) => planLookup.get(planId);

export const PLAN_LOOKUP = planLookup;

export const PLAN_IDS_BY_MODULE = {
  fleet: FLEET_PLAN_IDS,
  charger: CHARGER_PLAN_IDS,
  utility: UTILITY_PLAN_IDS,
};

export const PLAN_ID_TO_MODULE_MAP = PLAN_ID_TO_MODULE;

export const PLAN_STATUS_CONFIG = {
  fleet: FLEET_PLAN_IDS,
  charger: CHARGER_PLAN_IDS,
  utility: UTILITY_PLAN_IDS,
};

